<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>船舶名称：</p>
        <el-input v-model="shipIpt" size="mini" style="width:150px" placeholder="请输入船舶名称"/>
      </div>
      <div class="navContainer" style="width: 240px">
        <p>供应商名称：</p>
        <el-input v-model="supplierOutName" size="mini" style="width:150px" placeholder="请输入供应商名称"/>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择状态">
          <el-option v-for="item in stateOption1" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="shipOutName" label="转出船舶名" align="center"/>
          <el-table-column prop="voyageOutName" label="转出航次" align="center"/>
          <el-table-column prop="shipInName" label="转入船名" align="center"/>
          <el-table-column prop="voyageInName" label="转入航次" align="center"/>
          <el-table-column prop="taskPortName" label="作业港口" align="center"/>
          <el-table-column prop="unloadingDate" label="预计卸车时间" min-width="140" align="center">
            <div slot-scope="scope">{{getTime(scope.row.unloadingDate)}}</div>
          </el-table-column>
          <el-table-column prop="loadingDate" label="预计装车时间" min-width="140" align="center">
            <div slot-scope="scope">{{getTime(scope.row.loadingDate)}}</div>
          </el-table-column>
          <el-table-column prop="changeEntrustNum" label="预转船数量" align="center"/>
          <!-- <el-table-column prop="changeSupplierNum" label="实际装车数量" align="center"/> -->
          <el-table-column prop="state" label="状态" align="center">
            <div slot-scope="scope">{{getState(scope.row.status)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
              <div style="align-items:center;padding-left: 10px">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row)">详情</el-button>
                <el-button v-if="scope.row.status===0" size="mini" type="primary" @click="changeClick(scope.row.id)" class="yellow-bg">修改</el-button>
                <el-button v-if="scope.row.status===0" size="mini" type="danger" @click="deleteClick(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情转船任务" :visible.sync="detailDialogVisible" width='700px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">任务编号：</span>
              <span>{{detailData.taskNumber}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">转出船舶名称：</span>
                <span>{{detailData.shipOutName}}</span>
              </div>
              <div>
                <span class="span1">转入船舶名称：</span>
                <span>{{detailData.shipInName}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">转出船次：</span>
                <span>{{detailData.voyageOutName}}</span>
              </div>
              <div>
                <span class="span1">转入船次：</span>
                <span>{{detailData.voyageInName}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">作业港口：</span>
              <span>{{detailData.taskPortName}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">作业进港时间：</span>
                <span>{{detailData.arrivalDate}}</span>
              </div>
              <div>
                <span class="span1">装车进港时间：</span>
                <span>{{getTime(detailData.arrivalInDate)}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">卸车时间：</span>
                <span>{{getTime(detailData.unloadingDate)}}</span>
              </div>
              <div>
                <span class="span1">装车时间：</span>
                <span>{{getTime(detailData.loadingDate)}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">预计转出数量：</span>
                <span>{{detailData.changeEntrustNum}}</span>
              </div>
              <div>
                <span class="span1">作业数量：</span>
                <span>{{detailData.completeNum}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>转入船舶信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="shipData" border style="width: 100%">
              <el-table-column prop="name" label="船舶名" align="center"/>
              <el-table-column prop="sdi.voyageNumber" label="航次" align="center"/>
              <el-table-column prop="sdi.taskNumber" label="任务编号" align="center"/>
              <el-table-column prop="sdi.captainName" label="船长姓名" width="70px" align="center"/>
              <el-table-column prop="sdi.captainTel" label="船长电话" align="center"/>
              <el-table-column prop="callNumber" label="呼号" align="center"/>
              <el-table-column prop="phone" label="船舶电话" align="center"/>
              <el-table-column prop="sdi.portList[0].taskDate" label="装车时间" align="center"/>
            </el-table>
          </div>
        </div> -->
        <div class="operation">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>转驳车辆信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border style="width: 100%">
              <el-table-column prop="batchNumber" min-width="100" label="批次号" align="center"/>
              <el-table-column prop="billNumber" min-width="150" label="运单号" align="center"/>
              <el-table-column prop="frameNumber" min-width="150" label="车架号" align="center"/>
              <el-table-column prop="brand" label="品牌" align="center"/>
              <el-table-column prop="model" label="型号" align="center"/>
              <el-table-column prop="config" label="配置" align="center"/>
              <el-table-column prop="color" label="颜色" align="center"/>
              <el-table-column prop="fileName" label="附件" align="center"/>
              <el-table-column prop="personnelName" label="转入船舶" align="center"/>
            </el-table>
            <div class="paginationContainer" style="margin: 10px 0 0 0">
              <span>共{{detail.total}}条</span>
              <el-pagination
                background
                small
                :page-sizes="[10, 20, 30, 40]"
                layout="sizes,prev, pager, next,jumper"
                :total="detail.total"
                :current-page.sync="detail.page"
                @size-change="detailSizeChange"
                @current-change="detailChange"
                @prev-click="detailChange"
                @next-click="detailChange"
              />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :width='dialogWidth' center @close="dialogClose" :close-on-click-modal="false" top="10vh">
      <div class="company">
        <el-form :model="teamData" label-width="100px" :rules="rules" ref="ruleForm">
          <div-border label="转出设置">
            <div style="width: 70%;margin: auto">
              <el-form-item label="转出船舶：" prop="ship" style="margin-top: 15px">
                <el-select v-model="teamData.ship" filterable size="mini" style="width:100%" placeholder="请选择船舶" @change="shipChange" value-key="id">
                  <el-option v-for="item in shipOption" :key="item.id" :label="item.shipName" :value="item.shipId"/>
                </el-select>
              </el-form-item>
              <div style="display:flex;flex-direction:column;padding-left:30px;" v-if="teamData.ship">
                <div style="display:flex;align-items:center;width:100%;margin-bottom:10px;">
                  <span style="width:100%;color: #606266;font-weight: 700">航次：<span>{{shipDetails.voyageNumber?shipDetails.voyageNumber:'-'}}</span></span>
                </div>
                <div style="display:flex;align-items:center;width:100%;margin-bottom:10px;">
                  <span style="width:45%;color: #606266;font-weight: 700">船长姓名：<span>{{shipDetails.shipName?shipDetails.shipName:'-'}}</span></span>
                  <span style="color: #606266;font-weight: 700">船长手机号：<span>{{shipDetails.shipPhone?shipDetails.shipPhone:'-'}}</span></span>
                </div>
              </div>
              <el-form-item label="作业港口：" prop="start_port">
                <el-select v-model="teamData.start_port" filterable size="mini" style="width:100%" placeholder="请选择作业港口" value-key="id" @change="portChange">
                  <el-option v-for="item in startOption" :key="item.id" :label="item.supplier_name" :value="item"/>
                </el-select>
                <span v-if="teamData.start_port" class="protAdderss" style="color: rgb(153, 153, 153);font-size: 12px;position: absolute;bottom: -25px;left: 0px;">{{teamData.start_port.address}}</span>
              </el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="进港时间：" prop="arrivalTime" style="margin-bottom: 20px;">
                    <el-date-picker
                      type="datetime"
                      @change="portChange"
                      v-model="teamData.arrivalTime"
                      size="mini"
                      style="width:100% "
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="请选择卸车时间"/>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="卸车时间：" prop="unloadTime" style="margin-bottom: 20px;">
                    <el-date-picker
                      type="datetime"
                      @change="portChange"
                      v-model="teamData.unloadTime"
                      size="mini"
                      style="width:100% "
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="请选择卸车时间"/>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

          </div-border>
          <div-border label="选择转入船舶">
            <div class="productTable" style="margin:20px 0">
              <el-table
                :data="teamData.shipTable"
                style="width: 100%"
                border
                :header-cell-style="{color:'#7F7F7F','font-size':'13px',height:'35px'}"
                :cell-style="{color:'#7F7F7F','font-size':'13px'}">
               <!-- <el-table-column label="装车时间" prop="time" align="center" width="200px">
                 <template slot-scope="scope">
                   <el-date-picker
                     size="mini"
                     style="width: 100%"
                     v-model="shipTable[scope.$index].time"
                     type="datetime"
                     placeholder="请选择装车时间"
                     value-format="yyyy-MM-dd HH:mm:ss"/>
                 </template>
               </el-table-column> -->

                <el-table-column label="船舶名" prop="dpName" align="center">
                  <template slot-scope="scope">
                    <el-form-item :prop="`shipTable[${scope.$index}].dpName`" :rules="rules.dpName" label-width="0px">
                      <el-select v-model="scope.row.dpName" filterable value-key="id" placeholder="请选择船舶名" size="mini" @change="shipSelectChange(scope.$index,scope.row.dpName)">
                        <el-option
                          v-for="item in shipOptions2"
                          :key="item.id"
                          :label="item.name"
                          :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="航次" prop="voyageNumber" align="center"/>
                <el-table-column label="船长姓名" prop="shipName" align="center"/>
                <el-table-column label="船长电话" prop="shipPhone" align="center"/> -->
                <el-table-column label="进港时间" prop="arrivalTime" align="center">
                  <template slot-scope="scope">
                    <el-form-item :prop="`shipTable[${scope.$index}].arrivalTime`" :rules="rules.arrivalTime"
                                  label-width="0px">
                      <el-date-picker
                        v-model="scope.row.arrivalTime"
                        size="mini"
                        type="date"
                        placeholder="进港时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="装车时间" prop="time" align="center">
                  <template slot-scope="scope">
                    <el-form-item :prop="`shipTable[${scope.$index}].time`" :rules="rules.time"
                                  label-width="0px">
                      <el-date-picker
                        v-model="scope.row.time"
                        size="mini"
                        type="date"
                        placeholder="装车时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="转入数量" prop="into" width="80" align="center">
                  <template slot-scope="scope">
                    <el-form-item :prop="`shipTable[${scope.$index}].into`" :rules="rules.into" label-width="0px">
                      {{scope.row.into}}
                    </el-form-item>

                  </template>
                </el-table-column>
<!--                <el-table-column label="呼号" prop="callNumber" align="center"/>-->
<!--                <el-table-column label="船舶电话" prop="phone" align="center"/>-->
                <el-table-column label="操作"  align="center" width="170px">
                  <template slot-scope="scope">
                    <el-button  size="mini" type="danger" v-if="teamData.shipTable.length > 1" @click="deleteClick2(scope.$index)">删除</el-button>
                    <el-button size="mini" type="primary" @click="addEntrust(scope.$index)">添加委托车</el-button>
                  </template>
                </el-table-column>
                <div slot="append" style="padding:9px">

                  <el-button type="warning" size="medium" icon="el-icon-plus" circle style="padding: 4px;"
                             @click="addMaterial">
                  </el-button>
                  <span style="margin:10px">添加车辆</span>
                </div>
              </el-table>
            </div>
          </div-border>
        </el-form>
        <div class="btnContainer">
          <el-button class="searchBtn" :loading="dialogLoading" @click="saveClick" size="small">确定</el-button>
          <el-button class="resetBtn" @click="dialogClose" size="small">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="选择委托车" :visible.sync="dialogEntrust" width='800px' center
               @close="dialogEntrustClose" :close-on-click-modal="false" top="10vh">
      <addEntrust @tableId="EntrustSelectChange" ref="addEntrust" :selectTableId="entrustId" :type="`转船`" :position-data="{shipId:teamData.ship}"></addEntrust>

    </el-dialog>
  </div>
</template>

<script>
import divBorder from '@/components/divBorder'
import addEntrust from "./compoent/addEntrust";
import {
  changeShipInfoCvPageList,supplierPublicSelectPort,transferInfoCvDetail,
  changeShipSelectShipByInTask,changeShipInfoCvDelete,pageLighteringList,
  changeShipInfoCvAdd,changeShipInfoCvUpdate,changeShipSelectShipInByFree,
} from '@/service/vehiclelog'
import {formatDateTime} from "@/config/mUtils";

export default {
  components: {
    divBorder,
    addEntrust,
  },
  data() {
    let  validatePass2 =function (rule, value, callback) {
      if (value ==='未添加'){
        callback(new Error('请添加委托车!'));
      }else if (value ==0){
        callback(new  Error('请添加委托车!'))
      }
      callback();

    }
    return {
      portIpt:'',
      voyageIpt:'',
      shipIpt:'',
      voyageIpt2:'',
      timeIpt:'',
      numberIpt:'',
      stateIpt:'',
      supplierOutName:"",
      stateOption1:[
        {value:'',label:'全部',},
        {value:0,label:'待执行',},
        {value:1,label:'已卸车',},
        {value:2,label:'部分已完成',},
        {value:3,label:'已完成',},
      ],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[],
      // 详情
      detailDialogVisible:false,
      detailData:{},
      shipData:[],
      operationData:[],
      detail: {
        page: 1,
        total: 0,
        size: 10,
      },

      dialogTitle:'',
      dialogVisible:false,
      dialogEntrust:false,
      EntrustTableIndex:'',
      entrustId:[],
      dialogWidth:'',
      shipOption:[],
      carTable:[],
      startOption:[],
      shipTable:[],
      teamData:{
        ship:'',
        unloadTime:'',
        arrivalTime:'',
        shipTable:[
          {dpName:'',voyageNumber:'',shipName:'',shipPhone:'',arrivalTime:'',time:'',into:'未添加',entrustId: [],shipOptions2:[]},
        ],
        carPort:'',
      },
      dialogLoading:false,//转船提交等待
      shipOptions2:[],
      shipMap:new Map(),
      shipId:'',//委托车船舶id查询
      shipDetails:{},
      rules:{
        ship:[
          { required: true, message: '请输入船舶名称', trigger: 'change' },
        ],
        dpName:[
          { required: true, message: '请选择船舶名', trigger: 'change' },
        ],
        into:[
          { required: true, message: '请添加委托车', trigger: 'change' },
          { validator: validatePass2, trigger: 'blur' }
        ],
        start_port:[
          { required: true, message: '请输入作业港口', trigger: 'change' },
        ],
        car1:[
          { required: true, message: '请输入交车港口', trigger: 'change' },
        ],
        basic:[
          { required: true, message: ' ', trigger: 'blur' },
        ],
        time2:[
          { required: true, message: '请选择进港时间', trigger: 'change' },
        ],
        time:[
          { required: true, message: '请选择卸车时间', trigger: 'change' },
        ],
        arrivalTime:[
          { required: true, message: '请选择进港时间', trigger: 'change' },
        ],
        unloadTime:[
          { required: true, message: '请选择卸车时间', trigger: 'change' },
        ],
        infor:[
          { required: true, message: ' ', trigger: 'blur' },
        ],
      },
      selectShip:[{id:0,name:'无',}],
    };
  },
  computed:{
    getState() {
      return function (state) {
        switch (state) {
          case 0:
            return '待执行'
          case 1:
            return '执行中'
          case 3:
            return '已完成'
        }
      };
    },
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy-mm-dd hh:ii:ss')
      };
    },
  },
  mounted() {
    this.init()
  },
  provide(){
    return{
      CloseDialog:this.dialogEntrustClose
    }
  },
  methods: {
    async init(){
      await this._changeShipInfoCvPageList()
    },
    async _changeShipInfoCvPageList(){
      this.tableLoad=true;
      const res = await changeShipInfoCvPageList(
        {
          shipOutName:this.shipIpt,
          supplierOutName:this.supplierOutName,
          voyageNumber:this.voyageIpt,
          taskNumber:this.numberIpt,
          taskPortName:this.portIpt,
          taskType:2,
          status:this.stateIpt,
          startTime:this.timeIpt[0]?this.timeIpt[0]:'',
          endTime:this.timeIpt[1]?this.timeIpt[1]:'',
          rows:this.size,
          page:this.page,
        }
      );
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total
    },
    saveClick(){
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          // if (this.shipTable.length===0) return this.$message.warning("必须至少有一个船舶信息！");
          // for(let i=0;i<this.shipTable.length;i++){
          //   if(!this.shipTable[i].time) return this.$message.warning("请选择转车时间！");
          // }
          // const arr =[];
          // this.carTable.forEach(item=>{
          //   if(item.ship.id) arr.push(item);
          // })
          let {start_port,arrivalTime,unloadTime,shipTable}=this.teamData
          const obj = {
            id:this.teamData.id,
            shipOutId:this.teamData.ship,
            voyageOutId:this.shipDetails.id,
            voyageNumber:this.shipDetails.voyageNumber,
            taskPortId:start_port.id,
            taskPortName:start_port.supplier_name,
            taskPortAreaId: start_port.area_id,
            taskPortAreaFullId: start_port.area_full_id,
            taskPortAreaName: start_port.area,
            taskAreaCoordinate: start_port.coordinate,
            // taskPortAddress:start_port.address,
            // taskCoordinate:`${start_port.longitude},${start_port.latitude}`,
            taskCoordinate:start_port.coordinate,
            unloadingDate:unloadTime,
            arrivalDate:arrivalTime,

            portList:shipTable.map(item=>{
              return{
                shipId:item.dpName.id,
                arrivalDate:item.arrivalTime,
                taskDate:item.time,
                carList:item.entrustId.map(item=>{
                  return{
                    id:item.id
                  }
                })
              }
            }),
          };
          this.dialogLoading = true
          const res = this.dialogTitle==='添加转船任务'?await changeShipInfoCvAdd(obj):await changeShipInfoCvUpdate(obj)
          this.dialogLoading = false
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.dialogVisible=false;
          await this._changeShipInfoCvPageList()
        } else return false;
      });
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._changeShipInfoCvPageList()
    },
    contractCurrentChange(page){
      this.page=page;
      this._changeShipInfoCvPageList()
    },
    // 详情
    async detailClick(row){
      this.detail.page = 1;
      this.detail.id = row.id;
      this.detailDialogVisible=true;
      const res = await transferInfoCvDetail(row.id);
      if(res.status !== 0) return this.$message.error(res.message);
      this.detailData=res.data;
      // this.shipData=res.data.waterSupplierShipList;
      // this.operationData=res.data.carList;
      this._carPageList();
    },
    // 详情 —— 分页查询
    async _carPageList() {
      let obj = {
        id: this.detail.id,
        rows:this.detail.size,
        page:this.detail.page,
      }
      const res = await pageLighteringList(obj);
      if(res.status !== 0) return this.$message.error(res.message);
      if(this.detail.taskType==2&&this.planType==1){
        if(res.data.records&&res.data.records.length>0){
          res.data.records.forEach(item => {
            item.state = parseInt(item.state)-1
          })
        }
      }
      this.operationData = res.data.records;
      this.detail.total = res.data.total;
    },
    // 详情 —— 分页大小改变
    detailSizeChange(size){
      // 每页条数
      this.detail.size = size;
      this._carPageList();
    },
    // 详情 —— 当前页改变
    detailChange(page){
      // 翻页
      this.detail.page = page;
      this._carPageList();
    },

    deleteClick(id){
      this.$confirm('确定要删除当前转船任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await changeShipInfoCvDelete(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._changeShipInfoCvPageList()
      }).catch(() => {});
    },
    deleteClick2(index){
      this.teamData.shipTable.splice(index,1)
    },
    dialogEntrustClose(){
      this.dialogEntrust = false
      this.$refs.addEntrust.close()
    },
    addEntrust(index){
      if (this.teamData.ship ==='') return this.$message.warning("请先选择转出船舶")
      this.EntrustTableIndex = index
      if (this.dialogTitle==='添加转船任务'){
        this.entrustId = this.teamData.shipTable[index].entrustId
        console.log(this.entrustId)
      }
      this.$nextTick(()=>{
        clearTimeout(this.timer)
        //调用子组件函数 回显数据
        this.$refs.addEntrust._changeShipSelectCarByShipIdAndOut()
        this.timer = setTimeout(()=>{
          this.$refs.addEntrust.selectEcho()
        }, 500);

      })
      this.dialogEntrust=true
    },
    addMaterial() {
      this.teamData.shipTable.push({
        dpName: '',
        voyageNumber: '',
        shipName: '',
        shipPhone: '',
        arrivalTime: '',
        time: '',
        into: '未添加',
        entrustId: [],
        shipOptions2: []
      },)
    },
    shipSelectChange(index,value) {
      let {shipmasterName,shipmasterPhone,voyageNumber,id} = value
      let obj = this.teamData.shipTable[index];
      obj.voyageNumber = voyageNumber;
      obj.shipName = shipmasterName;
      obj.shipPhone = shipmasterPhone;
      this.$set(this.teamData.shipTable, index, obj);
      this.$forceUpdate();
      // this.teamData.shipTable[index].voyageNumber = voyageNumber
      // this.teamData.shipTable[index].shipName = shipmasterName
      // this.teamData.shipTable[index].shipPhone = shipmasterPhone
      this.shipId = id
    },
    EntrustSelectChange(value) {
      this.teamData.shipTable[this.EntrustTableIndex].into = value.length
      this.teamData.shipTable[this.EntrustTableIndex].entrustId = value
      this.$refs.addEntrust.close()
      this.dialogEntrust = false
    },
    // 修改
    async changeClick(id){
      this.dialogTitle = '修改转船任务';
      this.dialogWidth = '750px';

      let res1 = await supplierPublicSelectPort()
      if (res1.status !==0) return this.$message.error(res1.message)
      this.startOption = res1.data
      // 转出船舶
      let res2 = await changeShipSelectShipByInTask()
      if (res2.status !==0) return  this.$message.error(res2.message)
      this.shipOption = res2.data
      res2.data.forEach(item=>{
        this.shipMap.set(item.shipId,item)
      })

      this.dialogVisible = true;
      const res = await transferInfoCvDetail(id);
      if(res.status !== 0) return this.$message.error(res.message);
      this.shipChange(res.data.shipOutId);
      this.teamData={
        ...res.data,
        ship:{id:res.data.shipId,name:res.data.shipName},
        start_port:{id:res.data.taskPortId,name:res.data.taskPortName,address:res.data.taskPortDetail},
        arrivalTime:res.data.arrivalDate,
        unloadTime:res.data.unloadingDate,
        voyageNumber: '',
        shipName: '',
        shipPhone: '',
        shipData:{},
        shipTable:res.data.waterSupplierShipList || [],
      };
    },
    searchBtn(){
      this.page = 1;
      this._changeShipInfoCvPageList()
    },
    resetBtn(){
      this.portIpt='';
      this.voyageIpt='';
      this.voyageIpt2='';
      this.shipIpt='';
      this.supplierOutName ='';
      this.timeIpt='';
      this.numberIpt='';
      this.stateIpt='';
    },
    async addBtn(){
      this.dialogTitle='添加转船任务';
      this.dialogWidth='700px';

      let res = await supplierPublicSelectPort()
      if (res.status !==0) return this.$message.error(res.message)
      this.startOption = res.data
      // 转出船舶
      let res2 = await changeShipSelectShipByInTask()
      if (res2.status !==0) return  this.$message.error(res2.message)
      this.shipOption = res2.data
      res2.data.forEach(item=>{
        this.shipMap.set(item.shipId,item)
      })
      this.dialogVisible=true;
    },
    dialogClose(){
      this.dialogVisible=false;
      this.$refs.ruleForm.resetFields();
    },
    async shipChange(arr){
      let response = await changeShipSelectShipInByFree(arr)
      if (response.status !==0) return this.$message.error(response.message)
      this.shipOptions2 = response.data

      this.teamData.shipTable.forEach(item=>{
        item.dpName='';
        item.voyageNumber='';
        item.shipName = '';
        item.shipPhone = '';
      })

      let {voyageNumber,shipmasterPhone,shipmasterName,id} =this.shipMap.get(arr)
      this.shipDetails={
        voyageNumber:voyageNumber,
        shipName:shipmasterName,
        shipPhone:shipmasterPhone,
        id:id
      }
    },
    async portChange(arr){

    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .btnContainer{
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0 5px 0;
    button{
      margin: 0 15px;
    }
  }
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          .addressItem{
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 10px;
            margin-left: 70px;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px 10px 10px;
    max-height:80vh;
    overflow: auto;
    .carTable{
      margin-top:20px;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
    }
    .transport{
      width:100%;
      border: 1px solid #C3C3C3;
      position:relative;
      padding:0 10px;
      margin-bottom: 20px;
      &Title{
        margin-bottom: 0;
        position:absolute;
        top: -21px;
        z-index: 999;
        background-color: #fff;
        left:20px;
        padding-right:10px;
        color: rgb(51, 84, 131);
        font-size: 15px;
        font-weight:700;
        ::v-deep{
          .el-form-item__label{
            color: rgb(51, 84, 131);
            font-size: 15px;
          }
        }
      }
    }
    .productTable{
      margin-top:15px;
      &Nav{
        display: flex;
        align-items: center;
        justify-content:space-between;
        margin-bottom: 10px;
        &Left{
          display: flex;
          align-items: center;
          ::v-deep{
            .el-input--mini .el-input__inner{
              height:22px;
            }
            .el-input__icon{
              height: 120%;
            }
          }
          span{
            color: #606266;
            font-weight: 700
          }
        }
        &Right{
          text-decoration: underline;
          color: rgb(51, 136, 255);
        }
      }
      ::v-deep{
        .el-checkbox{
          margin-left: 8px;
        }
        .el-input--mini .el-input__inner{
          width: 100%;
        }
        .el-form-item__error{
          top: 75%;
        }
        .el-form-item{

          margin: 7px 0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
        .el-table td, .el-table th{
          padding:1px;
        }
      }
      .tableAddBtnContainer{
        border: 1px solid #EBEEF5;;
        border-top-style: none;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 15px;
        .AddContainer{
          display: flex;
          align-items: center;
          &:hover{
            cursor: pointer;
          }
        }
        img{
          object-fit: cover;
          margin-right: 5px;
        }
        p{
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }
      }
    }
    .update{
      font-size: 14px;
      color: rgba(51, 136, 255, 1);
      text-decoration: underline;
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item{
        margin-bottom:15px;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0 5px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-form-item__label{
    font-weight: 700;
  }
  .el-table .ui-warning-row {
    background: #DDD!important;
  }
  .el-table .ui-warning-row .cell{
    color: red;
  }
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
    max-height: 70vh;
    overflow-y: auto;
  }
  .el-date-editor.el-input.el-input--mini.el-input--prefix.el-input--suffix.el-date-editor--date {
    width: auto !important;
  }
}
.paginationContainer {
  margin-right: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>
